export default {
  cookieExpires: 1,
  useFingerPrint: true,
  //mobAppActiveGroup: 98, //# gosmart
  mobAppActiveGroup: 9233, //# vetdrug
  //mobAppActiveGroup: 9237, //# asset
  
  mobApps: [
    {
      id: 98,      
      name: "main",
      key: 'zIGhSWMcrLTeOUvByGtMr1',
    },
    {
      id: 9233,
      name: "vet.med",
      key: 'HMk8BCDrIEe1hxj6f6JQyA',
      
      hasHomePage: true,
      defaultHome: 'vet-med',
    },
    {
      id: 9237,      
      name: "asset.ubtraffic",
      key: 'o_usZfT6uEqqyNdRP5vVpg',
    },
    {
      id: 9238,      
      name: "zhut.report",
      key: 'U1ZjGhgPIE_unNxET2TYwQ',
    },
    
  ]
};
